var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-4" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("h1", { staticClass: "h4 ls-tight" }, [
                  _vm._v("Crear ruta"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-success px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.CREATE()
                      },
                    },
                  },
                  [
                    _vm.count == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [_vm._v("Guardar")]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid max-w-screen-md vstack gap-3" },
          [
            _c(
              "div",
              [
                _c("small", { staticClass: "input-title" }, [_vm._v("Código")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.code,
                      expression: "data.code",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.code ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.code },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "code", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.code, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("small", { staticClass: "input-title" }, [_vm._v("Nombre")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.name,
                      expression: "data.name",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.name ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.name, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Entregar en: "),
                ]),
                _vm._v(" "),
                _c("v-autocomplete", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.branch ? "is-invalid" : "",
                  attrs: { items: _vm.delivers, "hide-details": "" },
                  on: { change: _vm.FRESH },
                  model: {
                    value: _vm.data.deliver_to,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "deliver_to", $$v)
                    },
                    expression: "data.deliver_to",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.deliver_to, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.data.deliver_to == 1
              ? _c(
                  "div",
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Sucursal: "),
                    ]),
                    _vm._v(" "),
                    _c("v-autocomplete", {
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.branch_office_id ? "is-invalid" : "",
                      attrs: {
                        "item-value": "id",
                        "item-text": "name",
                        items: _vm.branch_offices,
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.data.branch_office_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "branch_office_id", $$v)
                        },
                        expression: "data.branch_office_id",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(
                      _vm.errors.branch_office_id,
                      function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.data.deliver_to == 0
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 pl-0 pr-0 pr-lg-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("País: "),
                        ]),
                        _vm._v(" "),
                        _c("v-autocomplete", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            items: _vm.countries,
                            "item-text": "name",
                            "item-value": "id",
                            "hide-details": "",
                          },
                          on: { change: _vm.PROVINCES },
                          model: {
                            value: _vm.country_id,
                            callback: function ($$v) {
                              _vm.country_id = $$v
                            },
                            expression: "country_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 pl-0 pr-0 pr-lg-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Provincia: "),
                        ]),
                        _vm._v(" "),
                        _c("v-autocomplete", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            items: _vm.provinces,
                            "item-text": "name",
                            "item-value": "id",
                            "hide-details": "",
                          },
                          on: { change: _vm.CITIES },
                          model: {
                            value: _vm.province_id,
                            callback: function ($$v) {
                              _vm.province_id = $$v
                            },
                            expression: "province_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 pl-0 pr-0" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Cuidad: "),
                        ]),
                        _vm._v(" "),
                        _c("v-autocomplete", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            items: _vm.cities,
                            "item-text": "name",
                            "item-value": "id",
                            "hide-details": "",
                          },
                          on: { change: _vm.DISTRICTS },
                          model: {
                            value: _vm.city_id,
                            callback: function ($$v) {
                              _vm.city_id = $$v
                            },
                            expression: "city_id",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Distritos a Agregar: "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm" },
                      [
                        _c("v-autocomplete", {
                          staticClass: "form-control form-control-sm textarea",
                          attrs: {
                            items: _vm.districts,
                            "item-text": "name",
                            "item-value": "id",
                            "hide-details": "",
                            "small-chips": "",
                            multiple: "",
                            chips: "",
                          },
                          model: {
                            value: _vm.append_districts,
                            callback: function ($$v) {
                              _vm.append_districts = $$v
                            },
                            expression: "append_districts",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary px-3",
                              attrs: {
                                disabled: _vm.append_districts.length == 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.APPEND_DISTRICTS()
                                },
                              },
                            },
                            [_vm._v("Agregar")]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("small", { staticClass: "input-title" }, [
                        _vm._v("Distritos: "),
                      ]),
                      _vm._v(" "),
                      _c("v-autocomplete", {
                        staticClass: "form-control form-control-sm textarea",
                        class: _vm.errors.districts ? "is-invalid" : "",
                        attrs: {
                          items: _vm.get_districts,
                          "item-text": "name",
                          "item-value": "id",
                          "hide-details": "",
                          "small-chips": "",
                          multiple: "",
                          chips: "",
                        },
                        model: {
                          value: _vm.data.districts,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "districts", $$v)
                          },
                          expression: "data.districts",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.districts, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }